import * as React from "react";
const SvgFiRrBalloons = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-balloons_svg__a)">
      <path d="M18.848 11.53A7.7 7.7 0 0 0 19.977 8a1 1 0 0 0-2 0 5.7 5.7 0 0 1-.825 2.47 1.002 1.002 0 0 0 1.7 1.06zM8.977 7a1 1 0 0 0-1 1 5.7 5.7 0 0 1-.825 2.47 1.002 1.002 0 0 0 1.7 1.06A7.7 7.7 0 0 0 9.977 8a1 1 0 0 0-1-1" />
      <path d="M19.5 18.589c-.682-.362-1.386-.737-1.484-1.162-.046-.193-.025-.628.515-1.473C21.7 15.5 24 11.024 24 7a5.8 5.8 0 0 0-6-6 5.86 5.86 0 0 0-4.955 2.487A6.994 6.994 0 0 0 0 7c0 3.97 2.257 8.485 5.39 9.685-.217.36-.35.766-.39 1.185 0 1.57 1.489 2.267 2.576 2.776.6.28 1.424.665 1.424.963-.081.31-.227.6-.428.85a1 1 0 1 0 1.684 1.08c.424-.56.682-1.23.744-1.93 0-1.571-1.489-2.267-2.576-2.775-.6-.281-1.424-.666-1.433-.865a5.4 5.4 0 0 1 .568-1.016c2.352-.306 4.331-2.5 5.452-5.2a7.37 7.37 0 0 0 3.413 3.892 3.38 3.38 0 0 0-.356 2.238c.306 1.31 1.519 1.955 2.494 2.474.616.328 1.313.7 1.419 1.068.026.385-.085.767-.315 1.078a1 1 0 1 0 1.732 1 3.33 3.33 0 0 0 .506-2.627 4.17 4.17 0 0 0-2.404-2.287M7 14.999c-2.646 0-5-4.473-5-8a5 5 0 0 1 10 0c0 3.527-2.354 8-5 8m7-8a3.794 3.794 0 0 1 4-4 3.792 3.792 0 0 1 4 4c0 3.4-2.056 7-4 7s-4-3.6-4-7" />
    </g>
    <defs>
      <clipPath id="fi-rr-balloons_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBalloons;
